import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button,  Form, FormGroup, Input, Label } from 'reactstrap';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export default class ContractEdit extends Component {

    emptyItem = {
        startDate: '',
        signingDate: '',
        studentId: ''
    };

    

    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        if (this.props.match.params.id !== 'new') {
            const contract = await (await fetch(`/api/v1/contracts/${this.props.match.params.id}`)).json();

            this.setState({ item: contract });
        }
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item[name] = value;
        this.setState({ item });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { item } = this.state;

        await fetch('/api/v1/contracts' + (item.id ? '/' + item.id : ''), {
            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
        });
        this.props.history.push('/contracts');
    }

    render() {
        const { item } = this.state;
        const title = <h2>{item.id ? 'Edit Contract' : 'Add Contract'}</h2>;
        const Item = styled(Paper)(({ theme }) => ({
            ...theme.typography.body2,
            textAlign: 'left',
            color: theme.palette.text.secondary,
            height: 60,
            lineHeight: '60px',
        }));

        return <div>
            <Grid container sx={{ color: 'text.primary' }}>
                <Grid item xs={8}>
                    <Item elevation={0}>{title}</Item>
                </Grid>
                
                <Form onSubmit={this.handleSubmit}>

                    <Grid item xs={8}>
                        <Label for="name">Date Contrat</Label>
                        <Input type="text" name="startDate" id="startDate" value={item.startDate || ''}
                                onChange={this.handleChange} autoComplete="startDate" />
                    </Grid>
                    <Grid item xs={2}>
                        <Item>
                    <FormGroup>
                        <Label for="name">Date Signature</Label>
                        <Input type="text" name="signingDate" id="signingDate" value={item.signingDate || ''}
                            onChange={this.handleChange} autoComplete="signingDate" />
                            </FormGroup>
                        </Item>
                    </Grid>
                    <br/>
                    <FormGroup>
                        <Button color="primary" type="submit">Save</Button>{' '}
                        <Button color="secondary" tag={Link} to="/contracts">Cancel</Button>
                    </FormGroup>

                    
                    
                </Form>
            </Grid>
        </div>
    }


}
//export default withRouter(ContractEdit);